import React from 'react';
import Form from 'react-bootstrap/Form'
import InputGroup from "react-bootstrap/InputGroup"
import * as yup from 'yup';
import {DeliverTo} from './UA/Address';

export const schemaLastMileService = yup.object().shape({
    id: yup.number().positive().required(),
    code: yup.string(),
});

export class LastMileService extends React.Component {
    render() {
        const {
            values,
            lmsList,
        } = this.props;
        return (
            <Form.Group>
                <InputGroup>
                    <InputGroup.Prepend>
                        <InputGroup.Text>
                            <small>Last Mile Service</small>
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                        as="select"
                        value={values.lastMileService.id}
                        onChange={this.handleChange}
                    >
                        {lmsList.map(
                            (lms, index) => <option value={lms.id} key={index}>{lms.name}</option>)}
                    </Form.Control>
                </InputGroup>
            </Form.Group>
        )
    }

    handleChange = e => {
        const lmsId = e.target.value;
        this.props.setFieldValue('lastMileService.id', lmsId);
        let lms;
        for (lms of this.props.lmsList) {
            if (lms.id === parseInt(lmsId)) {
                this.props.setFieldValue('lastMileService.code', lms.code);
                break;
            }
        }
        if (lms.code === 'TMM') {
            this.props.setFieldValue('_deliverTo', DeliverTo.pickupPoint)
        } else {
            this.props.setFieldValue('_deliverTo', DeliverTo.door)
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        // To set lms when component is first time mounted.
        // componentDidMount has empty lmsList so this logic must be implemented here.
        const {setFieldValue} = this.props;
        if (prevProps.lmsList.length === 0 && this.props.lmsList.length > 0) {
            const firstLms = this.props.lmsList[0];
            setFieldValue('lastMileService.code', firstLms.code);
            setFieldValue('lastMileService.id', firstLms.id);
        }
    }

    componentDidMount() {
        const {setFieldValue} = this.props;
        const firstLms = this.props.lmsList[0];
        if (firstLms) {
            // Timeout is hack for formik, setFieldValue is not working in componentDidMount otherwise.
            setTimeout(() => {
                setFieldValue('lastMileService.code', firstLms.code);
                setFieldValue('lastMileService.id', firstLms.id);

            }, 0)
        }
    }
}

